'use strict';
const angular = require('angular');

export class serviceRequestInfoComponent {
  /*@ngInject*/
  constructor(Auth, dialogs, prompt, IntegrationService) {
    this.Auth = Auth;

    Auth.getCurrentUser(user => {
      this.user = user;
      this.userId = user._id;
      this.webaccessId = user.webaccessId;
      console.log(user);
    });
    this.IntegrationService = IntegrationService;

    this.dialogs = dialogs;
    this.prompt = prompt;
  }

  $onInit() {
    this.ticket = this.resolve.config.ticket;
  };

  ok() {
    this.close({$value: ''});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  addNote() {
    this.prompt({
      title: 'Add Message for Management',
      message: 'Add your message below',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let noteObj = {
        note: note,
        firstName: this.user.firstName,
        middleName: this.user.middleName,
        lastName: this.user.lastName,
        meta: {
          webaccessUser: this.webaccessId
        }
      };

      this.IntegrationService.patchServiceRequest({id: this.ticket._id}, [
        { "op": "add", "path": "/chat/-", "value": noteObj },
      ], data => {
        noteObj.meta.creationDate = new Date();
        this.ticket.chat.push(noteObj);
      });
    });
  }

  deleteNote(idx) {
    var dlg = this.dialogs.confirm("Delete Note?", "Do you really want to delete your note?<br/><br/>" + this.ticket.notes[idx].note);
    dlg.result.then(() => {
      this.IntegrationService.patchServiceRequest({id: this.ticket._id}, [
        { "op": "remove", "path": "/chat/"+idx },
      ], data => {
        this.ticket.chat.splice(idx,1);
      });
    },() => {
    });
  }

  getTextHtml(text) {
    return (text) ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : "";
  }

}

export default angular.module('conduuApp.serviceRequestInfoComponent', [])
  .component('serviceRequestInfoComponent', {
    template: require('./service-request-info.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: serviceRequestInfoComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/service-request-info/service-request-info.component.js